import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IconWithSpinner } from '@/core/IconWithSpinner.atom';
import seeqLogoDarkBlueSm from 'resources/img/Seeq_logo_darkBlue_sm.png';
import { getWorkbooksLink, returnToPreviousState } from '@/main/routing.utilities';
import { Link } from 'react-router-dom';
import { notifyError } from '@/utilities/screenshot.utilities';
import { formatMessage } from '@/utilities/logger.utilities';
import { headlessRenderMode } from '@/services/headlessCapture.utilities';

interface LoadErrorProps {
  header: string;
  message1: string;
  message2: string;
  retryInterval?: number;
}

export const LoadError: React.FunctionComponent<LoadErrorProps> = ({ header, message1, message2, retryInterval }) => {
  const { t } = useTranslation();

  useEffect(() => {
    notifyError(formatMessage`Could not load page: ${message1}. ${message2}`);
  }, [message1, message2]);

  useEffect(() => {
    if (!headlessRenderMode() && retryInterval) {
      const timeout = setTimeout(() => returnToPreviousState(), retryInterval);
      return () => clearTimeout(timeout);
    }
  }, [retryInterval]);

  return (
    <div className="flexColumnContainer flexCenter fullViewport splashScreen tw:text-black">
      <div className="container ml0 mr0">
        <div className="row flexJustifyCenter">
          <div className="span12">
            <div className="jumbotron text-center">
              <p>
                <img src={seeqLogoDarkBlueSm} />
              </p>
              <h2 className="mb10">{t(header)}</h2>
              <p>
                <span>{t(message1)}</span>
              </p>
              <p>
                <span>{t(message2)}</span>
              </p>
              {retryInterval ? <IconWithSpinner testId="loadErrorLoadingIcon" spinning={true} /> : null}
              <p>
                <Link to={getWorkbooksLink()} reloadDocument={true}>
                  {t('UNAUTHORIZED.WORKBOOK_OVERVIEW')}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
